import React from "react";
import { Button } from "../../components/common";
import { LessonCardViewProps } from "./types";
import CardWrapper from "../../components/LessonPlayer/CardWrapper";
import { ArrowLeftIcon } from "lucide-react";
import { useLessonCardViewHook } from "./useLessonCardViewHook";

const LessonCardView: React.FC<LessonCardViewProps> = ({
  currentCard,
  totalCards,
  currentCardIndex,
  canProceed,
  lessonId,
  onNextCard,
  onPreviousCard,
  onCompleteCard,
  onCardStateChange,
  isLessonCompleting = false,
}) => {
  const {
    isLastCard,
    handleCardComplete,
    handleNext,
    handlePrevious,
    isPreviousDisabled,
  } = useLessonCardViewHook({
    currentCard,
    totalCards,
    currentCardIndex,
    canProceed,
    lessonId,
    onNextCard,
    onPreviousCard,
    onCompleteCard,
    onCardStateChange,
  });

  if (!currentCard) {
    return (
      <div className="flex items-center justify-center min-h-96">
        <div className="text-gray-600">No cards available</div>
      </div>
    );
  }

  return (
    <>
      <div className="relative bg-white rounded-[10px] min-h-[75vh] p-4 max-sm:pb-24 sm:p-8 md:p-12 w-full overflow-hidden">
        <>
          <div>
            <CardWrapper
              card={currentCard}
              onCompletedSection={handleCardComplete}
              isLastSection={isLastCard}
              onCardStateChange={onCardStateChange}
              lessonId={lessonId}
            />
          </div>

          <div className="w-full absolute bg-white left-0 bottom-0 flex items-center gap-4 h-20 sm:pl-4 max-sm:justify-center">
            <Button
              variant="text"
              className="w-52 flex items-center gap-2 px-4 py-2 !text-pd-slate disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={handlePrevious}
              disabled={isPreviousDisabled}
            >
              <ArrowLeftIcon className="w-4 h-4" />
              Previous
            </Button>
            <Button
              className="flex items-center w-52 gap-2 px-4 py-2 bg-primary text-pd-cream disabled:opacity-50 disabled:cursor-not-allowed"
              variant="filled"
              onClick={handleNext}
              disabled={!canProceed || isLessonCompleting}
            >
              {isLastCard ? "Finish" : "Next"}
            </Button>
          </div>
        </>
      </div>
    </>
  );
};

export default LessonCardView;
